import React from 'react';
import { formatTime } from '../../utils/helpers';
import { useWeatherApi } from '../../context/WeatherApiContext';
import { PanelLeft } from 'lucide-react';

interface TopbarProps {
  isMobile: boolean;
  sidebarOpen: boolean;
  onToggleSidebar: () => void;
}

export const Topbar: React.FC<TopbarProps> = ({ isMobile, sidebarOpen, onToggleSidebar }) => {
  const [time, setTime] = React.useState(new Date());
  const { status } = useWeatherApi();

  React.useEffect(() => {
    const timer = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <header 
      className="border-b px-4 sm:px-6 lg:px-8 py-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between"
      style={{
        backgroundColor: 'rgba(28, 28, 30, 0.8)',
        borderColor: 'rgba(255, 255, 255, 0.1)',
        backdropFilter: 'blur(30px)',
      }}
    >
      <div className="flex items-center gap-3 min-w-0">
        {isMobile && !sidebarOpen && (
          <button
            type="button"
            onClick={onToggleSidebar}
            className="p-2 rounded-lg border border-white/10 bg-white/5 hover:bg-white/10 transition-colors"
            aria-label="Open sidebar"
          >
            <PanelLeft size={18} />
          </button>
        )}
        <div className="min-w-0">
          <h1 className="text-xl sm:text-2xl font-semibold truncate">Environmental Monitoring</h1>
          <p className="text-xs sm:text-sm text-gray-400 truncate">
            Real-time sensor data and system control
          </p>
        </div>
      </div>
      <div className="flex flex-wrap items-center gap-3 sm:gap-4">
        <div 
          className="px-3 sm:px-4 py-2 rounded-lg text-xs sm:text-sm flex items-center gap-2"
          style={{
            backgroundColor: 'rgba(28, 28, 30, 0.6)',
            border: '1px solid rgba(255, 255, 255, 0.1)',
          }}
        >
          <div
            className={`w-2 h-2 rounded-full ${
              status.connected ? 'bg-ios-green' : 'bg-gray-500'
            }`}
          />
          <span className={status.connected ? 'text-ios-green' : 'text-gray-400'}>
            {status.connected ? 'System Online - Live Data' : 'System Offline'}
          </span>
        </div>
        <div 
          className="px-3 sm:px-4 py-2 rounded-lg text-xs sm:text-sm font-mono"
          style={{
            backgroundColor: 'rgba(28, 28, 30, 0.6)',
            border: '1px solid rgba(255, 255, 255, 0.1)',
          }}
        >
          {formatTime(time)}
        </div>
      </div>
    </header>
  );
};

